import { DefaultState } from 'store/types';

export const POST_USER_REQUEST = 'POST_USER_REQUEST';
export const POST_USER_SUCCESS = 'POST_USER_SUCCESS';
export const POST_USER_FAILURE = 'POST_USER_FAILURE';


export interface PostUserParams {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  status: string;
  password?: string;
}

export interface PostUserRow {
  id: string;
  firstName: string;
  lastName: string;
  role: string;
}

export interface PostUserData {
  rows: PostUserRow[];
  totalCount: number;
}

export type PostUserState = DefaultState & {
  contents?: PostUserData;
};

interface PostUserRequest {
  type: typeof POST_USER_REQUEST;
}

interface PostUserSuccess {
  type: typeof POST_USER_SUCCESS;
  contents: PostUserData;
}

interface PostUserFailure {
  type: typeof POST_USER_FAILURE;
}

export type PostUserActionTypes = PostUserRequest | PostUserSuccess | PostUserFailure;